import { ServiceItem, CartItem } from '../types';

export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency: 'RUB',
    maximumFractionDigits: 0,
  }).format(amount);
};

export const calculatePriceRange = (service: ServiceItem, isUrgent: boolean): { min: number, max: number } => {
  let min = service.minPrice;
  let max = service.maxPrice;

  if (isUrgent) {
    // +30% average for urgency
    min = Math.round(min * 1.3);
    max = Math.round(max * 1.3);
  }

  return { min, max };
};

export const calculateCartTotal = (items: CartItem[], isUrgent: boolean): { min: number, max: number } => {
  let totalMin = 0;
  let totalMax = 0;

  items.forEach(item => {
    const { min, max } = calculatePriceRange(item.service, isUrgent);
    totalMin += min;
    totalMax += max;
  });

  return { min: totalMin, max: totalMax };
};